import { ReactElement } from "react";

export interface RouteData {
    routeProps: RouteProps;
    name: string;
}

export interface RouteProps {
    path: string;
    element: ReactElement<any, any>
}

export interface Action<T> {
    type: string,
    payload: T
}

export interface KeyValuePayload {
    key: string,
    value: any
}

export interface AuthModel {
    username: string,
    password: string,
    otp?: string
}

export interface OtpAuthModel {
    username: string,
    password: string,
    otp: string
}

export interface ValidatorResponse {
    isValidated: boolean,
    message: string
}

export interface TransactionPayload {
    shouldSendMail?: boolean,
    accountNumber?: string,
    startDate?: Date,
    endDate?: Date,
    profileID?: number;
}

export interface IBank {
    id: number,
    bankName: string,
    bankCode: string,
    bankAlias: string
}

export interface ITransfer {
    senderAccount: string, 
    amount: string, 
    beneficiaryAccount: string, 
    expenseCategory: string, 
    senderName: string,
    remarks: string, 
    frequency: string, 
    startDate: string, 
    endDate: string, 
    beneficiaryBank: string, 
    beneficiaryName: string, 
    beneficiaryBankCode: string, 
    pin: string,
    isSelfTransfer?: boolean,
    shouldSaveBeneficiary: boolean,
    canSaveBeneficiary?: boolean,
    reminder?: string,
    transferType?: number,
    nipSession: string,
    accountTier?: number|null
}

export interface ICardProfile {
    bin: string,
    description: string,
    displayName: string,
    id: number,
    schemeOwner: string,
    sponsorBank: string
}

export interface IDeliveryOption {
    institutionCode: string,
    optionDescription: string,
    shortForm: string,
    id: number
}

export interface InstitutionProfileDCardData {
    cardProfiles: Array<ICardProfile>,
    deliveryOptions: Array<IDeliveryOption>,
    requestType?: Array<string>
}

export interface ICardDetails {
    nameOnCard: string,
    accountNumber: string,
    cardPAN: string,
    linkedDate: string,
    expiryDate: string,
    serialNo: string,
    status: string
}

export interface INotifications {
    // id: number,
    // title: string,
    // message: string
    date: string,
    info: Array<any>
}

export interface IExpenseCategory {
    id: number,
    name: string,
    description: string,
    isDeleted: boolean
}

export interface InstitutionData {
    id: number,
    institutionCode: string,
    name: string,
    logo: string,
    address: string,
    website: string,
    correspondenceEmail: string,
    correspondencePhone: string,
    emailSenderID: string,
    setupDate: string,
    goLiveDate: string,
    primaryColour: string,
    secondaryColour: string,
    primaryColour2: string,
    secondaryColour2: string,
    tertiaryColour: string,
    urlSuffix: string,
    hasTransfer: boolean,
    hasBillsPayment: boolean,
    hasAirtimeTopUp: boolean,
    hasAccountOpening: boolean,
    paystackSubAccountCode: string,
    paystackSubAccountName: string,
    paystackBank: string,
    shouldLockNewProfile: boolean,
    defaultOneTimeTransactionLimit: number,
    defaultDailyTransactionLimit: number,
    testAccountNumber: string,
    testAccountCustomerID: string,
    testAccountUsername: string,
    quickTellerURL: string,
    institutionType: string,
    pilotPhaseMaximumUserCount: number,
    implementationPhase: string,
    defaultAccountOpeningProductCode: string,
    defaultAccountOfficerCode: string,
    ussdCode: string,
    allowedAccountProductCodes: string,
    disallowedAccountProductCodes: string,
    connectionString: string,
    personalizedDomain: string,
    transferGateway: string,
    maximumOneTimeTransactionLimit: number,
    maximumDailyTransactionLimit: number,
    alias: string,
    twoFactorThresholdAmount: number
}

export type OnboardingSideData = {
    id: number,
    title: string,
    body: string
}

export type CardRequestStatusData = {
    id: number,
    status: 'Validated' | 'Approved' | 'Generated' | 'FullyReceived' | 'FullyRecieved' | 'Declined',
    batchNo: string,
    nameOnCard: string,
    createdAt: string,
    updatedAt: string,
    accountNumber: string,
    profileID: number,
    isCompleted: boolean
}

export type MFB_HostName = {
    hostName: string,
    mfb: string
}

export type InsightChartProps = {
    categories: Array<string>,
    amount: Array<number>
}

export enum Design {
    DESIGN_1 = 1,
    DESIGN_2 = 2,
    DESIGN_3 = 3
}

export enum Features {
    INTRA_BANK_TRANSFER = '1',
    AIRTIME_TOPUP = '2',
    BILLS_PAYMENT = '3',
    BANKONE_LOAN = '4:BankOne',
    RECOVA_LOAN = '4:Recova',
    CARDS = '5',
    FIXED_DEPOSIT = '6',
    TARGET_SAVINGS = '7',
    INTER_BANK_TRANSFER = '11',
    NEW_CUSTOMER_ONBOARDING = '12',
    EXISTING_CUSTOMER_ONBOARDING = '13'
}

export type AccountUpgrade = {
    accountNumber: string,
    address: string,
    nin: string,
    bvn: string,
    validIDBase64: string,
    validIDExtension: string,
    utilityBase64: string,
    utilityExtension: string,
    signatureBase64: string,
    signatureExtension: string,
    passportBase64: string,
    passportExtension: string
}